import React from 'react';

import { isPhone } from '@helpers';

import Mobile from './components/mobile';
import Tablet from './components/tablet';

import { connect } from 'react-redux';
import ColorWrapper from '@styles/colors';

import { close } from '@reducers/clampingTools';
import { edit } from '@reducers/tools';

const ClampingTool = (props) => {
  const { largeView } = props;

  const p = { ...props };

  return isPhone || !largeView ? <Mobile {...p} /> : <Tablet {...p} />;
};

const mapStateToProps = ({ clampingTools }) => ({ clampingTools });

export default connect(mapStateToProps, { close, edit })(ColorWrapper(ClampingTool));
